interface KeyboardArrowHandler {
    direction: 'down' | 'up'
    previousSelection: FilterType
}

const handleKeyboardArrow = ({ direction, previousSelection }: KeyboardArrowHandler): FilterType => {
    if (direction === 'down') {
        switch (previousSelection) {
            case 'ALL_VEHICLES':
                return 'VEHICLES_IN_SALE'
            case 'VEHICLES_IN_SALE':
                return 'VEHICLES_SOLD'
            case 'VEHICLES_SOLD':
                return 'COMPANIES'
            case 'COMPANIES':
                return 'AGENTS'
            case 'AGENTS':
                return 'ALL_VEHICLES'
            default:
                throw new Error('Undefined filtertype passed to handleKeyboardArrow in SearchBar component')
        }
    } else {
        // direction === 'up'
        switch (previousSelection) {
            case 'AGENTS':
                return 'COMPANIES'
            case 'COMPANIES':
                return 'VEHICLES_SOLD'
            case 'VEHICLES_SOLD':
                return 'VEHICLES_IN_SALE'
            case 'VEHICLES_IN_SALE':
                return 'ALL_VEHICLES'
            case 'ALL_VEHICLES':
                return 'AGENTS'
            default:
                throw new Error('Undefined filtertype passed to handleKeyboardArrow in SearchBar component')
        }
    }
}

export default handleKeyboardArrow
